import * as React from 'react';

import { withTranslation } from '@i18n';
import {
  StyledCover,
  StyledHeading,
  StyledPartnerHospital,
  StyledHospital,
  StyledDiv
} from './styles';

const PartnetHospital = ({ t }) => (
  <>
    <StyledCover>
      <StyledHeading>
        {t('hero.OurHospitals')}
      </StyledHeading>
      <StyledPartnerHospital>
        <StyledDiv>
          <StyledHospital src="../../../static/images/home/ApolloHospital.webp" alt="Logo Apollo Hospital" />
        </StyledDiv>
        <StyledDiv>
          <StyledHospital src="../../../static/images/home/FortisHospital.webp" alt="Logo Fortis Hospital" />
        </StyledDiv>
        <StyledDiv>
          <StyledHospital src="../../../static/images/home/AsterHospital.webp" alt="Logo Aster Hospital" />
        </StyledDiv>

        <StyledDiv>
          <StyledHospital src="../../../static/images/home/MedicalPark.webp" alt="Logo Medical Park" />
        </StyledDiv>

        <StyledDiv>
          <StyledHospital src="../../../static/images/home/LIVHospital.webp" alt="Logo LIV Hospital" />
        </StyledDiv>

        <StyledDiv>
          <StyledHospital src="../../../static/images/home/MemorialHospital.webp" alt="Logo Memorial Turkey" />
        </StyledDiv>

        <StyledDiv>
          <StyledHospital src="../../../static/images/home/ACIBADEM.webp" alt="Logo ACIBADEM" />
        </StyledDiv>

        <StyledDiv>
          <StyledHospital src="../../../static/images/home/UAE.webp" alt="Logo HCG Hospital" />
        </StyledDiv>

        <StyledDiv>
          <StyledHospital src="../../../static/images/home/MaxHospital.webp" alt="Logo Max Hospital" />
        </StyledDiv>

        <StyledDiv>
          <StyledHospital src="../../../static/images/home/MedicalCity.webp" alt="Logo Clinicana Turkey" />
        </StyledDiv>

        <StyledDiv>
          <StyledHospital src="../../../static/images/home/BangkokHospital.webp" alt="Logo Bangkok Hospital" />
        </StyledDiv>

        <StyledDiv>
          <StyledHospital src="../../../static/images/home/BumrungradHospital.webp" alt="Logo Bumrungrad Hospital" />
        </StyledDiv>

      </StyledPartnerHospital>
    </StyledCover>
  </>
);

export default withTranslation('Home')(PartnetHospital);
